var React = require('react');

function Spotify (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 1.04a10.96 10.96 0 1 0 0 21.93 10.96 10.96 0 0 0 0-21.93zm5.03 15.81a.68.68 0 0 1-.94.23c-2.58-1.57-5.82-1.93-9.63-1.06a.68.68 0 0 1-.3-1.33c4.17-.96 7.75-.54 10.64 1.22.32.2.42.62.23.94zm1.34-2.98a.85.85 0 0 1-1.18.28c-2.94-1.81-7.44-2.34-10.92-1.28a.86.86 0 0 1-.5-1.64c3.98-1.2 8.93-.62 12.32 1.46.4.25.53.77.28 1.18zm.11-3.11c-3.53-2.1-9.36-2.3-12.73-1.27a1.03 1.03 0 1 1-.6-1.96c3.87-1.18 10.31-.95 14.38 1.46a1.02 1.02 0 1 1-1.05 1.77z"}));
}

Spotify.defaultProps = {"width":"24","height":"24","aria-label":"Spotify","viewBox":"0 0 24 24"};

module.exports = Spotify;

Spotify.default = Spotify;
